import { createReducer } from "@reduxjs/toolkit";
import { GetAdversitment, GetCustomerMaster, Getoffers } from "./CustomerMasterThunk";



const handleAsyncActions = (builder, action, dataKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[dataKey] = true;
            state[dataKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[dataKey] = false;
            // state.customerList = action.payload.getCustomerMasters;
            // state.monthSalesData = action.payload.yearWiseMonthSales;
            state[dataKey] = action.payload;
            state.error[errorKey] = null;
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[dataKey] = false;
            state.error[errorKey] = action.payload;
        });
};

const initialState = {
    // Data for each API
    GetCustMaster: null,
    AdversitmentImage:null,
    Getoffersdata:null,
    // Dynamic loading and error states for each API
    loading: {
      GetCustMaster: false,
      AdversitmentImage:false,
      Getoffersdata:false,
    },

    error: {
      GetCustMasterError: null,
      AdversitmentImageError:null,
      GetoffersError:null,
    },
};

export const CustomerMasterReducer = createReducer(initialState, (builder) => {
    // Handle async actions using the utility function
    handleAsyncActions(builder, GetCustomerMaster, 'GetCustMaster', 'GetCustMasterError');
    handleAsyncActions(builder, GetAdversitment, 'AdversitmentImage', 'AdversitmentImageError');
    handleAsyncActions(builder, Getoffers, 'Getoffersdata', 'GetoffersError');



    
});

export default CustomerMasterReducer;